import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
	},
	{
		path: 'board',
		loadChildren: () => import('./pages/board/board.module').then( m => m.BoardPageModule)
	},
	{
		path: 'add-request',
		loadChildren: () => import('./pages/add-request/add-request.module').then( m => m.AddRequestPageModule)
	},
	{
		path: 'updates',
		loadChildren: () => import('./pages/updates/updates.module').then( m => m.UpdatesPageModule)
	},
  {
    path: 'status',
    loadChildren: () => import('./pages/status/status.module').then( m => m.StatusPageModule)
  },
  {
    path: 'weekly-scorecard',
    loadChildren: () => import('./pages/weekly-scorecard/weekly-scorecard.module').then( m => m.WeeklyScorecardPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
